export default '/pricing/macos';
